import { ref, shallowReactive } from 'vue'
import { defineStore } from 'pinia'

export default defineStore('snapshot', () => {
  const key = ref('')
  const takePictureTouch = shallowReactive({
    isSaveDone: false,
    isUpload: false,
  })
  const transform = shallowReactive({
    scale: 1,
    left: 0,
    top: 0,
    width: 0,
    height: 0
  })
  // The board shows only the low-quality placeholder, the full image is still on its way
  const isPlaceholder = ref(false)

  function setTakePictureTouch (takePictureTouch) {
    this.$patch({ takePictureTouch })
  }

  function setPlaceholder (value) {
    isPlaceholder.value = value
  }

  function setKey (key) {
    this.$patch({ key })
  }

  function setTransform (transform) {
    this.$patch({ transform })
  }

  return {
    key,
    takePictureTouch,
    transform,
    isPlaceholder,
    setKey,
    setTakePictureTouch,
    setTransform,
    setPlaceholder
  }
})
